/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// Backstage HeaderTabs — NS/Tractie overrides (POC R3).
//
// Source: node_modules/@backstage/core-components/dist/layout/HeaderTabs/HeaderTabs.esm.js
// JSS name: "BackstageHeaderTabs"
// Class keys: tabsWrapper | defaultTab | selected | tabRoot
//
// Afwijkingen van core-components t.o.v. de Tractie tab-design (Figma
// node 1692:17456, TRACTIE Tabs):
//   - textTransform "uppercase" -> sentence case ("Overview", niet "OVERVIEW").
//   - inactieve tab: Roboto Regular 400, size-m (16px), kleur content/subtle
//     (core-components default = caption 12px, fontWeightBold, text.secondary).
//   - actieve tab: Roboto Bold 700, kleur content/selected (#0062d1) — de
//     onderstreping is al blauw via de MuiTabs-indicator-override, de tab-tekst
//     hoort mee te kleuren (core-components default = text.primary, bijna-zwart).
//
// MuiTab overrides in ns-theme werken NIET voor HeaderTabs omdat HeaderTabs
// een eigen JSS-laag heeft (BackstageHeaderTabs.defaultTab/selected) die via
// `className`/`classes` direct wordt toegekend; die wint van MuiTab-root door
// specificity. Daarom overriden we hier de BackstageHeaderTabs-keys zelf.
// `selected` staat na `defaultTab` in de sheet en wint dus op gelijke
// specificity voor de actieve tab (kleur + weight).

const headerTabsBase = {
  // tabsWrapper achtergrond: core-components zet hier `background.paper` (wit),
  // wat een witte band onder de tabs geeft. Figma zet de tabs transparant op de
  // page-achtergrond -> transparant.
  tabsWrapper: {
    backgroundColor: 'transparent',
  },
  // core-components HeaderTabs styles the tab as caption (12px) on its own
  // defaultTab JSS, which wins over MuiTab-root by specificity. So size-m (16px)
  // must be set here, on the tab root, to override that 12px. The nested label
  // (Typography variant="button") is sized separately via theme.typography.button.
  // Pin leading-l (1.5) so the row lands at 48px (without it the tabs inherit
  // ~1.66, making the button render 48.5px and the link render 50.55px).
  defaultTab: {
    textTransform: 'none' as const,
    fontWeight: 400,
    fontSize: 'var(--ns-font-size-m)',
    lineHeight: 'var(--ns-font-leading-l)',
    color: 'var(--ns-color-fg-subtle)',
  },
  selected: {
    color: 'var(--ns-color-fg-selected)',
    fontWeight: 700,
  },
  // Spacing-model van Figma's TRACTIE Tabs: de tab heeft GEEN horizontale
  // padding (zodat de actieve onderstreping strak om de tekst zit) en MUI's
  // default minWidth (160px) wordt opgeheven. De 24px-ruimte komt als gap
  // tussen de tabs via marginInlineEnd (gap-l). Verticale padding 12px
  // (inset-s) houdt de rij op 48px.
  tabRoot: {
    minWidth: 0,
    padding: '12px 0',
    marginInlineEnd: 'var(--ns-space-gap-l)',
  },
};

export const BackstageHeaderTabsLightOverrides = headerTabsBase;
export const BackstageHeaderTabsDarkOverrides = headerTabsBase;
